import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AppContext } from './AppContext';
import { ROUTES } from './common/constants';
import LoaderComponent from './components/LoaderComponent';

function PublicRoute() {
  const { authLoading, authUser } = useContext(AppContext);

  if (authLoading) {
    return <LoaderComponent />;
  }
  return authUser ? <Navigate to={ROUTES?.MAIN} /> : <Outlet />;
}

export default PublicRoute;
